import { render, staticRenderFns } from "./CostBreakdown.vue?vue&type=template&id=6f92f327"
import script from "./CostBreakdown.vue?vue&type=script&lang=js"
export * from "./CostBreakdown.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports